// extracted by mini-css-extract-plugin
export var company = "Form-module--company--jCAA8";
export var download = "Form-module--download---xpNm";
export var email = "Form-module--email---Z980";
export var firstname = "Form-module--firstname--7v9GU";
export var form = "Form-module--form--OsGvH";
export var input = "Form-module--input--wfT01";
export var job = "Form-module--job--+NiSz";
export var lastname = "Form-module--lastname--0ut1z";
export var legend = "Form-module--legend--6ERB-";
export var message = "Form-module--message--osbqs";
export var moreInfos = "Form-module--moreInfos--PkFkV";
export var show = "Form-module--show--vAdHS";
export var submit = "Form-module--submit--cQbUx";
export var title = "Form-module--title--fgdFE";
export var titleImg = "Form-module--titleImg--mC3E6";
export var wrapper = "Form-module--wrapper--Ex4xE";